export default "__VITE_ASSET__BtM9QzOt__"